<div class="modal-header">
  <h4 class="modal-title">{{ 'Historique du sinistre'|transloco }}</h4>
  <dismiss (click)="activeModal.dismiss('Cross click')"></dismiss>
</div>

<div class="modal-body">
  <tableHistoriqueSinistre [historiques]="historiques" [operation]="operation"></tableHistoriqueSinistre>
</div>
